/* 
 * Spec AJAX add-to-cart — integrates with Dawn's native cart drawer/notification 
 * and pub/sub events. Progressive enhancement: falls back to a normal form post 
 * if anything goes wrong. No page reload. 
 */ 
(function () { 
  'use strict'; 
  if (window.__specAddToCart) return; 
  window.__specAddToCart = true; 
 
  function getCart() { 
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer'); 
  } 
 
  function updateBubble() { 
    fetch('/cart.js', { headers: { Accept: 'application/json' } }) 
      .then(function (r) { return r.json(); }) 
      .then(function (cart) { 
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (n) { 
          n.textContent = cart.item_count; 
        }); 
      }) 
      .catch(function () {}); 
  } 
 
  function performAdd(formData, btn, onFail) { 
    var labelEl = btn ? (btn.querySelector('[data-sp-add-label]') || btn) : null; 
    var original = btn ? btn.innerHTML : ''; 

    function restore() { 
      if (btn) { 
        btn.disabled = false; 
        btn.removeAttribute('aria-busy'); 
        btn.innerHTML = original; 
      } 
    } 

    if (btn) { 
      btn.disabled = true; 
      btn.setAttribute('aria-busy', 'true'); 

      if (labelEl) {
        labelEl.textContent = 'A adicionar…'; 
      }
    } 
 
    var cart = getCart(); 

    if (cart && typeof cart.getSectionsToRender === 'function') { 
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      ); 

      formData.append('sections_url', window.location.pathname); 

      if (typeof cart.setActiveElement === 'function' && document.activeElement) { 
        cart.setActiveElement(document.activeElement); 
      } 
    } 
 
    fetch('/cart/add.js', { 
      method: 'POST', 
      headers: { 
        Accept: 'application/json' 
      }, 
      body: formData 
    }) 
      .then(function (r) { 
        return r.json(); 
      }) 
      .then(function (res) { 

        if (res.status) { 
          if (labelEl) {
            labelEl.textContent = 'Indisponível'; 
          }

          setTimeout(restore, 1600); 
          return; 
        } 

        try { 
          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) { 
            publish(PUB_SUB_EVENTS.cartUpdate, { 
              source: 'spec-product-card', 
              productVariantId: formData.get('id'), 
              cartData: res 
            }); 
          } 
        } catch (err) {} 
 
        if (cart && typeof cart.renderContents === 'function') { 
          cart.renderContents(res); 
        } else { 
          updateBubble(); 
        }

        /*
         * FIX:
         * Quando o carrinho estava vazio, Dawn mantém a classe
         * "is-empty" no <cart-drawer>.
         *
         * O produto já foi adicionado e renderizado, por isso
         * removemos essa classe para as linhas do produto ficarem
         * visíveis imediatamente.
         */
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        if (labelEl) {
          labelEl.textContent = 'Adicionado ✓'; 
        }

        setTimeout(restore, 1500); 
      }) 
      .catch(function () { 
        restore(); 

        if (typeof onFail === 'function') {
          onFail(); 
        }
      }); 
  } 
 
  // PDP product form (data-spc-add on the <form>) 
  document.addEventListener('submit', function (e) { 
    var form = e.target.closest('form[data-spc-add]'); 

    if (!form) return; 

    e.preventDefault(); 

    var btn = form.querySelector('button[type="submit"]'); 

    performAdd(new FormData(form), btn, function () { 
      form.submit(); 
    }); 
  }); 
 
  // Product card Add button (data-spc-add on a <button> inside the card <a>) 
  document.addEventListener('click', function (e) { 
    var btn = e.target.closest('button[data-spc-add]'); 

    if (!btn || btn.closest('form[data-spc-add]')) return; 

    e.preventDefault(); 
    e.stopPropagation(); 

    var id = btn.getAttribute('data-variant-id'); 

    if (!id) return; 

    var fd = new FormData(); 
    fd.append('id', id); 
    fd.append('quantity', '1'); 

    performAdd(fd, btn); 
  }); 
 
})(); 